export default "__VITE_ASSET__CeB2XUwd__"